module.exports = __webpack_public_path__ + "img/ola-logo.2624ebe4.png";